import React from "react"
import { ScheduleContext } from "../../../contexts"

const ScheduleContextProvider = ({ config, children }) => {
  return <ScheduleContext.Provider value={config}>{children}</ScheduleContext.Provider>
}

export default ScheduleContextProvider
